import { axiosInstances, getAxiosHeaders } from './config/axios';
import { routes } from './config/routes';

interface CookieConsent {
  necessary: boolean;
  preferences: boolean;
  analytics: boolean;
  marketing: boolean;
}

interface ConsentRequest {
  consentType: 'cookie';
  consentPayload: {
    cookiesConsent: CookieConsent[]
  };
}

interface ConsentResponse {
  success: boolean;
  message: string;
  data: unknown;
}

export const saveUserConsent = async (consentRequest: ConsentRequest): Promise<ConsentResponse> => {
  // eslint-disable-next-line prettier/prettier
  const { data } = await axiosInstances.webWallet!.post<ConsentResponse>(
    routes.account.consent,
    consentRequest,
    getAxiosHeaders()
  );

  return data;
};
